import React, { memo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Radio } from '@node-space/ui-components'
import { DepositBankAccount } from 'types/BankAccountsDetails'
import { BankTransferType } from 'types/beneficiaries'
import { Currencies, WalletType } from 'types/types'
import { getPaymentTitle } from 'utils/wallet'
import LocalDetails from './LocalDetails'
import SwiftDetails from './SwiftDetails'

interface SingleDepositDetailsProps {
  bankAccounts: DepositBankAccount[]
  wallet: WalletType
}

const MultipleDepositDetails = ({ bankAccounts, wallet }: SingleDepositDetailsProps) => {
  const { t } = useTranslation()

  const [selectedBankAccount, setSelectedBankAccount] = useState<number>(0)

  const options = bankAccounts?.map((account, index) => ({
    label: getPaymentTitle(account, t),
    value: index?.toString(),
  }))

  const handleOnDepositAccountChange = (value: string) => {
    setSelectedBankAccount(Number(value))
  }

  return (
    <>
      <Radio
        name="depositAccount"
        horizontal
        onChange={value => handleOnDepositAccountChange(value)}
        key="depositAccount"
        testId="depositAccount"
        options={options}
        value={selectedBankAccount?.toString()}
      />

      <>
        {bankAccounts?.[selectedBankAccount]?.isSwift ||
        bankAccounts?.[selectedBankAccount]?.accountNumberFormat === BankTransferType.SWIFT ? (
          <SwiftDetails options={bankAccounts?.[selectedBankAccount]} />
        ) : (
          <LocalDetails
            currency={wallet?.currency?.code as Currencies}
            options={bankAccounts?.[selectedBankAccount]}
            wallet={wallet}
            isSegregated
          />
        )}
      </>
    </>
  )
}

export default memo(MultipleDepositDetails)
